import getUrlParam from 'qj/getUrlParam';
import React from 'react';
import Icons, { IconNames } from './icons';
import List from './list';
import VesselListItemSimple from './vesselListItemSimple';

export default class VisitListOverviewSimple extends React.Component {
  constructor(props) {
    super(props);

    this.renderListItems = this.renderListItems.bind(this);
    this.voyageParam = getUrlParam('voyage');

    this.state = { showChildren: null };
  }

  mapItemsVoyages(VoyagesDTO) {
    if (!VoyagesDTO) {
      return [];
    }

    const headers = {
      Reference: 'Voyage',
    //   Name: 'Vessel',
    //   Description: 'Line'
    };

    const vessels = VoyagesDTO.map(item => {
      return {
        Reference: item.reference,
        Name: item.vessel.name,
        Description: item.description,
        Icon: (
          <Icons
            iconName={IconNames.SortRight}
            iconClassName="arrowRight"
            className="arrowRightWrapper"
          />
        ),
        Visits: item.visits
      };
    });

    return { vessels, headers };
  }

  renderListItems() {
    const { vessels, headers } = this.mapItemsVoyages(this.props.voyages);
    const self = this;
    const items = vessels.map((item, index) => {
      return (
        <VesselListItemSimple
          key={index}
          tag="div"
          items={item}
          className={'list__items__item simple'}
          headers={headers}
          showingGMT={self.props.showingGMT}
          onToggleChildren={self.onToggleChildren}
          visits={item.Visits}
        />
      );
    });

    return <ul className="list__items">{items}</ul>;
  }

  render() {
    const { headers } = this.mapItemsVoyages(this.props.voyages);

    return (
      <List
        headers={headers}
        showingGMT={this.props.showingGMT}
        renderListItems={this.renderListItems}
        hideHeaders
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/visitListOverviewSimple.js